import { mpPorPack } from './reglasPedido';

// Conserva la cantidad física y el importe al cambiar la presentación.
export const cambiarUnidadCompra = (detalle, cambios) => {
  const anterior = detalle.requierePack ? mpPorPack(detalle) : 1;
  const nuevo = { ...detalle, ...cambios };
  if (detalle.requierePack && cambios.requierePack === false) {
    nuevo.nombreCompra = detalle.materiaPrima?.nombre || "";
  }
  const siguiente = nuevo.requierePack ? mpPorPack(nuevo) : 1;
  const totalMP = (Number(detalle.cantidad) || 0) * anterior;
  return { ...nuevo, cantidad: totalMP / siguiente, totalMP,
    precioEstimado: (Number(detalle.precioEstimado) || 0) * siguiente / anterior };
};
